import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { ReplaceStep } from '@tiptap/pm/transform';
import { isRemoteYjsTransaction } from './is-remote-yjs-transaction';
export const CollapseSpaces = Extension.create({
    name: 'collapseSpaces',
    addOptions() {
        return {
            getSetting: undefined,
        };
    },
    addProseMirrorPlugins() {
        const getSetting = this.options.getSetting || (() => true);
        return [
            new Plugin({
                key: new PluginKey('collapseSpaces'),
                appendTransaction: (transactions, _oldState, newState) => {
                    const enabled = getSetting();
                    if (!enabled) {
                        return null;
                    }
                    const shouldProcess = transactions.some((tr) => {
                        if (tr.getMeta('hyphenToDash') || tr.getMeta('collapseSpaces')) {
                            return false;
                        }
                        if (tr.getMeta('undo') || tr.getMeta('redo') || tr.getMeta('addToHistory') === false) {
                            return false;
                        }
                        if (isRemoteYjsTransaction(tr)) {
                            return false;
                        }
                        return tr.docChanged;
                    });
                    if (!shouldProcess) {
                        return null;
                    }
                    try {
                        const docSize = newState.doc.content.size;
                        const tr = newState.tr;
                        const replacements = [];
                        const safeTextBetween = (from, to, defaultText = '') => {
                            try {
                                if (from < 0 || to < 0 || from > docSize || to > docSize || from > to) {
                                    return defaultText;
                                }
                                return newState.doc.textBetween(from, to, '');
                            }
                            catch (error) {
                                return defaultText;
                            }
                        };
                        const findAffectedRange = () => {
                            let minPos = docSize;
                            let maxPos = 0;
                            transactions.forEach((transaction) => {
                                if (!transaction.docChanged || isRemoteYjsTransaction(transaction)) {
                                    return;
                                }
                                transaction.steps.forEach((step) => {
                                    if (step instanceof ReplaceStep) {
                                        const from = step.from;
                                        const to = step.to;
                                        if (from >= 0 && to >= 0 && from <= docSize && to <= docSize) {
                                            minPos = Math.min(minPos, from);
                                            maxPos = Math.max(maxPos, to);
                                        }
                                    }
                                });
                            });
                            const scanWindow = 4;
                            return {
                                start: Math.max(0, minPos - scanWindow),
                                end: Math.min(docSize, maxPos + scanWindow),
                            };
                        };
                        const range = findAffectedRange();
                        let consecutiveSpacesStart = -1;
                        let consecutiveSpacesCount = 0;
                        for (let pos = range.start; pos <= range.end && pos < docSize; pos++) {
                            const char = safeTextBetween(pos, pos + 1);
                            if (char === ' ') {
                                if (consecutiveSpacesStart === -1) {
                                    consecutiveSpacesStart = pos;
                                    consecutiveSpacesCount = 1;
                                }
                                else {
                                    consecutiveSpacesCount++;
                                }
                            }
                            else {
                                if (consecutiveSpacesCount > 1) {
                                    replacements.push({
                                        pos: consecutiveSpacesStart,
                                        length: consecutiveSpacesCount,
                                    });
                                }
                                consecutiveSpacesStart = -1;
                                consecutiveSpacesCount = 0;
                            }
                        }
                        if (consecutiveSpacesCount > 1) {
                            replacements.push({
                                pos: consecutiveSpacesStart,
                                length: consecutiveSpacesCount,
                            });
                        }
                        if (replacements.length > 0) {
                            replacements.reverse().forEach(({ pos, length }) => {
                                try {
                                    if (pos >= 0 && pos + length <= docSize) {
                                        tr.replaceWith(pos, pos + length, newState.schema.text(' '));
                                    }
                                }
                                catch (error) {
                                    console.error(`[CollapseSpaces] Error replacing at position ${pos}:`, error);
                                }
                            });
                            tr.setMeta('collapseSpaces', true);
                            return tr;
                        }
                        return null;
                    }
                    catch (error) {
                        console.error('[CollapseSpaces] Error in appendTransaction:', error);
                        return null;
                    }
                },
            }),
        ];
    },
});
//# sourceMappingURL=collapse-spaces.js.map